import { __assign, __read, __spread } from "tslib";
import { fillWithEmptyKeys } from '../../../utils';
import { KEEN_KEY, PROPERTIES_CONNECTOR } from '../../../constants';
export var categoricalChartTransformation = function (result, parserSettings) {
    var _a;
    var mainProperty = parserSettings.mergePropertiesOrder[0];
    var additionalProperties = parserSettings.mergePropertiesOrder.slice(1);
    var parsedResults = [];
    var generatedKeys = new Set();
    var extractKeyFromRecord = function (keysToExtract, record) {
        var recordKey = '';
        keysToExtract.forEach(function (key) {
            return (recordKey +=
                recordKey !== ''
                    ? " " + PROPERTIES_CONNECTOR + " " + record[key]
                    : record[key]);
        });
        return recordKey;
    };
    if (additionalProperties.length === 0) {
        var resultObject_1 = (_a = {},
            _a[KEEN_KEY] = mainProperty,
            _a);
        result.forEach(function (record) {
            var recordKey = record[mainProperty] !== null
                ? record[mainProperty].toString()
                : "" + null;
            generatedKeys.add(recordKey);
            resultObject_1[record[mainProperty]] = record.result;
        });
        parsedResults = [resultObject_1];
    }
    else {
        result.forEach(function (record) {
            var _a, _b;
            var parsedResultIndex = parsedResults.findIndex(function (data) {
                return data[KEEN_KEY] === record[mainProperty];
            });
            var generatedKey = extractKeyFromRecord(additionalProperties, record);
            generatedKeys.add(generatedKey);
            if (parsedResultIndex > -1) {
                return (parsedResults[parsedResultIndex] = __assign(__assign({}, parsedResults[parsedResultIndex]), (_a = {}, _a[generatedKey] = record.result, _a)));
            }
            parsedResults.push((_b = {},
                _b[KEEN_KEY] = record[mainProperty],
                _b[generatedKey] = record.result,
                _b));
        });
    }
    return {
        data: fillWithEmptyKeys(__spread(generatedKeys), parsedResults, 0),
        keys: __spread(generatedKeys),
    };
};
